export class LoginRequest {
  public userName: string;
  public password: string;
    constructor() { }
  }